export default "__VITE_ASSET__82d2c2f7__"